/**
 * pages/home/contato.ts
 * Envia o formulário de contato via fetch e exibe toast de feedback.
 */

import Toast from '@components/toast';
import * as Validation from '@helpers/validation';

const TEXTO_ENVIAR   = 'Enviar mensagem →';
const HTML_ENVIANDO  = '<span class="btn-spinner"></span> Enviando...';

export function init(params: { url: string }) {
    const form = document.getElementById('formContato') as HTMLFormElement | null;
    const btn  = document.getElementById('btnEnviarContato') as HTMLButtonElement | null;

    if (!form || !btn) return;

    Validation.init(form);

    form.addEventListener('submit', async (e) => {
        e.preventDefault();

        if (!Validation.validar(form)) {
            Toast.warning('Preencha todos os campos obrigatórios.');
            return;
        }

        btn.disabled   = true;
        btn.innerHTML  = HTML_ENVIANDO;

        try {
            const res  = await fetch(params.url, {
                method: 'POST',
                body:   new FormData(form),
            });

            const json = await res.json() as { sucesso: boolean; mensagem: string };

            if (json.sucesso) {
                Toast.success(json.mensagem);
                form.reset();
                form.querySelectorAll('.is-valid, .is-invalid').forEach(el => {
                    el.classList.remove('is-valid', 'is-invalid');
                });
            } else {
                Toast.error(json.mensagem);
            }
        } catch {
            Toast.error('Erro de conexão. Tente novamente ou escreva para contato@linkflowtech.com.br.');
        } finally {
            btn.disabled  = false;
            btn.innerHTML = TEXTO_ENVIAR;
        }
    });
}
